import { date, number, object, SchemaOf } from "yup";
import { requiredFieldValidationMessage } from "../../../Forms/ValidationMessages";
import { RateAgreement } from "../RateAgreement";

export const rateAgreementSchema: SchemaOf<RateAgreement> = object()
  .shape({
    RateAgreementNumber: number()
      .integer()
      .positive()
      .required(requiredFieldValidationMessage("Rate Agreement Number")),
    CarrierId: number().positive(requiredFieldValidationMessage("GSDB")),
    StartDate: date().required(requiredFieldValidationMessage("StartDate")),
    // CarrierName: string().required(requiredFieldValidationMessage("Name")),
  })
  .required();
